import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const SITE_DEFAULTS = {
  company_name: "Auto Thurm",
  company_street: "Wildenreuth A 55",
  company_city: "92681 Erbendorf",
  company_phone: "09682 722",
  company_email: "info@auto-thurm.de",
  opening_hours: "Mo - Fr: 8:00 - 12:00 & 13:00 - 17:00\nSa & So: Geschlossen",
};

let cache = null;
let pending = null;

const load = () => {
  if (!pending) {
    pending = axios
      .get(`${API}/settings`)
      .then((r) => (cache = { ...SITE_DEFAULTS, ...r.data }))
      .catch(() => SITE_DEFAULTS)
      .finally(() => setTimeout(() => (pending = null), 10000));
  }
  return pending;
};

export const telHref = (phone) => {
  const digits = (phone || "").replace(/[^\d+]/g, "");
  return `tel:${digits.startsWith("0") ? "+49" + digits.slice(1) : digits}`;
};

export const hoursLines = (info) =>
  (info.opening_hours || "").split("\n").map((l) => l.trim()).filter(Boolean);

export default function useSiteInfo() {
  const [info, setInfo] = useState(cache || SITE_DEFAULTS);
  useEffect(() => {
    let alive = true;
    load().then((d) => alive && setInfo(d));
    return () => {
      alive = false;
    };
  }, []);
  return info;
}
